import "./AyurvedaBanner.css";
 import Aos from "aos";
  import "aos/dist/aos.css";
  import { useEffect } from "react";

  
export default function AyurvedaBanner() {
 
    useEffect(() => {
    Aos.init({
      duration: 1000,      // animation duration
      easing: "ease-in-out",
      once: true,          // animation happens only once
      offset: 100,         // offset from the trigger point
    });
  
    Aos.refresh(); // optional but recommended
  }, []);
  return (
   <section className="container-fluid aybb-wrapper d-flex align-items-center" data-aos="fade-down">
  <div className="container text-center">
        <h1 className="ayb-heading head-font" style={{color:'wheat'}}>
          Reconnect With Your True Self
        </h1>

        <p className="para-font" style={{fontSize:'17px',fontWeight:'bold',color:'wheat'}}>
          Step away from your busy, stressful life and experience the traditional way of healing in a peaceful riverside setting, where nature, silence, and time-honored practices come together to restore balance and calm.
        </p>

      <button
  className="btn"
  style={{ backgroundColor: "#016400", color: "white" }}
  onClick={() =>
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    })
  }
>
  Learn More
</button>


 
      </div>
   </section>

  );
}
